module.exports = __webpack_public_path__ + "static/media/phone.9b15e985.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/phone.png
// module id = ./src/common/images/phone.png
// module chunks = 1